export default {
    convertSortOptionsToQueryParam(sortOptions) {
        return Object.keys(sortOptions)
            .map(key => key + ":" + (sortOptions[key] ? "desc" : "asc"))
            .join(",")
    },
}